module.exports = "<div *ngIf=\"isVisible\" class=\"spinner-container\">\n  <mat-spinner></mat-spinner>\n</div>\n"